// Timing between phonemes in the Blending Studio (ms) — slower first, then faster.
export const BLEND_SLOW_MS = 800;
export const BLEND_FAST_MS = 250;

// Shared timing constants for game feedback animations
export const GAME_FEEDBACK_MS = 900;
export const GAME_SUCCESS_MS = 1400;

// Donation UI
export const DONATION_QUICK_AMOUNTS = [5, 10, 25, 50];

// Payment status polling
export const PAYMENT_POLL_MAX_ATTEMPTS = 8;
export const PAYMENT_POLL_INTERVAL_MS = 2000;
